import * as PrintStyle from './../prints/index.js'
import util from '@/helper/util'

export default {
  async order(item, callback) {
    this.orders([item], callback)
  },
  async orders(items, callback) {
    let results = []
    Object.entries(items).forEach(([, item]) => {
      if (!item?.line_items) return
      Object.entries(item?.line_items).forEach(([, lineItem]) => {
        results.push({
          QRCode: lineItem.identify,
          QRSize: 96,
          identify: item?.sale_detail?.external_identify,
          buyerName: item?.delivery_info?.name,
          buyerNote: item?.delivery_info?.note,
          sellerNote: item.note,
          seller: item?.seller,
          manufacturer: item?.manufacturer,
          lineItemAttributes: Object.entries(lineItem?.attributes || []).reduce((result, [key, value]) => {
            result[lineItem.attributes_name?.[key]?.label || key] = value
            return result
          }, {}),
          lineItemNote: lineItem.note,
          lineItemSku: lineItem.sale_detail?.more?.sku,
          numberLineItem: item.line_items.length
        })
      })
    })

    let css = `body {font-size:12px;word-break: break-all;font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"}`
    let style = PrintStyle[`OrderStyle${util.options?.order?.print_style}`] || PrintStyle[`OrderStyle5x3`]
    util.print({
      html: await style.html(results),
      size: style.size,
      style: `${css}${style.css}`,
      callback
    })
  },
  async designIdea(items, callback) {
    let results = []
    Object.entries(items).forEach(([, item]) => {
      results.push({
        QRCode: item.id,
        QRSize: 96,
        id: item?.id,
        name: item?.name,
        sku: item?.sku,
        creator: item?.user_name,
        designer: item?.designer_name
      })
    })

    let css = `body {font-size:12px;word-break: break-all;font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"}`
    let style = PrintStyle[`DesignIdeaStyle${util.options?.design_idea?.print_style}`] || PrintStyle[`DesignIdeaStyle7x5`]
    util.print({
      html: await style.html(results),
      size: style.size,
      style: `${css}${style.css}`,
      callback
    })
  }
}
